import { render, staticRenderFns } from "./MenuOverviewCard.vue?vue&type=template&id=2d0fe1c8&scoped=true&"
import script from "./MenuOverviewCard.vue?vue&type=script&lang=js&"
export * from "./MenuOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuOverviewCard.vue?vue&type=style&index=0&id=2d0fe1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fe1c8",
  null
  
)

export default component.exports